module.exports = __webpack_public_path__ + "img/logo@2x.4172c40e.png";